<div class="modal-header">
  <h3 class="modal-title">
    {{
      role == 'staff'
        ? ('competitionModule.addStaffMember' | translate)
        : ('competitionModule.addPlayer' | translate)
    }}
  </h3>
  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'wcag.close' | translate }}"
    (click)="cancel()"
  >
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onFormSubmit()">
    <div class="mb-4">
      <label id="emailId" class="form-label">
        {{ 'general.email' | translate }}:
      </label>

      <input
        aria-labelledby="emailId"
        aria-describedby="emailIdError"
        id="email"
        type="email"
        inputmode="email"
        class="form-control"
        formControlName="email"
        placeholder="{{ 'general.email' | translate }}"
        [attr.aria-invalid]="
          form.controls.email.dirty && form.controls.email.invalid
            ? 'true'
            : null
        "
        (input)="onSearchMember($event.target.value)"
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        role="alert"
        id="emailIdError"
        *ngIf="form.controls.email.dirty && form.controls.email.invalid"
      >
        {{ 'general.email' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div *ngIf="role == 'player'" class="mb-4">
      <label id="numberId" class="form-label">
        {{ 'general.number' | translate }}:
      </label>
      <input
        aria-labelledby="numberId"
        aria-describedby="number"
        class="form-control"
        type="number"
        inputmode="numeric"
        formControlName="number"
        min="0"
        [attr.aria-invalid]="
          form.controls.number.dirty && form.controls.number.invalid
            ? 'true'
            : null
        "
      />
      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="number"
        role="alert"
        *ngIf="form.controls.number.dirty && form.controls.number.invalid"
      >
        {{ 'general.number' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>
    <div *ngIf="form.controls.functionId && role == 'player'" class="mb-4">
      <label id="functionId1" class="form-label">
        {{ 'competitionModule.playerFunction' | translate }}
      </label>
      <div
        *ngIf="form.controls.functionId"
        [attr.aria-invalid]="
          form.controls.functionId?.dirty && form.controls.functionId?.invalid
            ? 'true'
            : null
        "
      >
        <custom-select
          [ariaLabelledby]="'functionId1'"
          [ariaDescribedby]="'functions'"
          formControlName="functionId"
          [selectableItems]="
            functions
              | mapToSelectableItemsPipe: 'id' : 'playerFunction' : 'simple'
          "
          [clearable]="false"
          [valueBinder]="'id'"
          [emptyInitValue]="true"
          [allowSelectNullValue]="true"
        ></custom-select>

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="functions"
          role="alert"
          *ngIf="
            form.controls.functionId?.dirty && form.controls.functionId?.invalid
          "
        >
          {{ 'competitionModule.playerFunction' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>
    </div>
    <div
      class="mb-4"
      *ngIf="role == 'staff' && (competitionStaffFunctions$ | async)?.length"
    >
      <label id="functionId2" class="form-label">{{
        'competitionModule.staffFunction' | translate
      }}</label>
      <div
        *ngIf="form.controls.functionId"
        [attr.aria-invalid]="
          form.controls.functionId?.dirty && form.controls.functionId?.invalid
            ? 'true'
            : null
        "
      >
        <custom-select
          [ariaLabelledby]="'functionId2'"
          [ariaDescribedby]="'functionError'"
          formControlName="functionId"
          [selectableItems]="
            competitionStaffFunctions$
              | async
              | mapToSelectableItemsPipe: 'id' : 'staffFunction' : 'simple'
          "
          [clearable]="false"
          [valueBinder]="'id'"
          [emptyInitValue]="true"
          [allowSelectNullValue]="true"
        ></custom-select>

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="functionError"
          role="alert"
          *ngIf="
            form.controls.functionId?.dirty && form.controls.functionId?.invalid
          "
        >
          {{ 'competitionModule.staffFunction' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>
      <!-- <div class="col">
          <select class="form-select" formControlName="functionId">
            <option [ngValue]="null" selected>
              {{ 'general.select' | translate }}
            </option>
            <option
              *ngFor="let staffFunction of competitionStaffFunctions$ | async"
              [value]="staffFunction.id"
            >
              {{ staffFunction.staffFunction }}
            </option>
          </select>

          <p
            class="invalid-feedback" aria-atomic="true"
            role="alert"
            *ngIf="
              form.controls.functionId.dirty && form.controls.functionId.invalid
            "
          >
            {{ 'general.value' | translate }}
            {{ 'general.isRequired' | translate }}
          </p>
        </div> -->
    </div>

    <div class="d-flex justify-content-end">
      <button
        [disabled]="!form.dirty || isSubmitButtonDisabled"
        type="submit"
        (click)="onFormSubmit()"
        class="btn btn-primary"
      >
        {{
          selectedMember
            ? role == 'player'
              ? ('competitionModule.weKnowThisPlayerAddToTheTeam' | translate)
              : ('competitionModule.addStaffMember' | translate)
            : ('competitionModule.addMemberToTheTeam' | translate)
        }}
      </button>
    </div>
  </form>
</div>
